export default __webpack_public_path__ + "static/about-zurnai-community-mobile-12c8c3bcb0e5d63b661131345ce4545f.mp4";